// api/cast.ts — (B101) Admin → Cast: /api/admin/cast-candidates/*, the backend's door to ingest's cast candidates.
import { apiGet, apiPost } from "./client.ts";
import type { CastSet, CastKind } from "@/lib/cast.ts";

const P = "/admin/cast-candidates";
export const castApi = {
  create: (b: { entityKind: CastKind; name: string; description: string; groupCount?: number; style: string }) =>
    apiPost<{ id: string; status: "generating"; poll: string }>(P, b),
  get: (id: string) => apiGet<CastSet>(`${P}/${encodeURIComponent(id)}`),
  pick: (id: string, candidate: number) =>
    apiPost<{ entityId: string; setId: string; candidate: number; entityKind: CastKind; name: string; pickedBy: string }>(`${P}/${encodeURIComponent(id)}/pick`, { candidate }),
};
